// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__yzwf2","description":"PatientConsentPreview_description__32uJT"};